import { render, staticRenderFns } from "./dianp.vue?vue&type=template&id=056c958d&scoped=true"
import script from "./dianp.vue?vue&type=script&lang=js"
export * from "./dianp.vue?vue&type=script&lang=js"
import style0 from "./dianp.vue?vue&type=style&index=0&id=056c958d&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056c958d",
  null
  
)

export default component.exports